import './index.less'
import Login from "./Login";
import Navigation from "./Navigation";
import FailedFiles from "./FailedFiles";
import { useTranslation } from '../../hooks/useTranslation';

/**
 *
 * @author dongdong.fdd
 * @Company AutoNavi Co.,Ltd.
 * @date 2023/7/29 15:19
 */
function Header() {
  const { t } = useTranslation();
  const systemTitle = (window as any).systemTitle || t('system.title');

  return (
    <div
      className="Header"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0px 16px',
        height: '56px',
        background: 'white',
        alignItems: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}
    >
      <div
        className="left"
        style={{
          display: 'flex',
          alignItems: 'center',
          minWidth: '0',
          flexShrink: 0,
        }}
      >
        <img 
          src={"https://z.wiki/u/KJ7pV4z8H"}
          width={24} 
          height={24} 
          title={systemTitle} 
          alt={systemTitle} 
        />
        <span
          className="system-title"
          style={{
            paddingLeft: '10px',
            "height": "20px",
            "fontFamily": "PingFangSC",
            "fontWeight": 400,
            "fontSize": "12px",
            "color": "#4C5362",
            "lineHeight": "20px",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {systemTitle}
        </span>
      </div>
      
      <div className="center" style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
        <Navigation />
      </div>
      
      <div className="right" style={{ flexShrink: 1, display: 'flex', alignItems: 'center', gap: '8px', overflowX: 'hidden' }}>
        <FailedFiles />
        <Login />
      </div>
    </div>
  );
}

Header.propTypes = {}

export default Header
